const SOURCE_LABELS = {
  website: "Website",
  shopify: "Shopify",
  wordpress: "WordPress",
  admin: "Admin",
  unknown: "Unknown",
};

export const getMembershipPlanLabel = (item) =>
  item?.display_duration_label ||
  (item?.duration_type === 1
    ? "Monthly"
    : item?.duration_type === 2
    ? "Semi-Annual"
    : item?.duration_type === 3
    ? "Days"
    : "--");

export const getMembershipTermLabel = (item) =>
  item?.membership_term_label || getMembershipPlanLabel(item);

export const getMembershipTermShort = (item) => {
  const label = getMembershipTermLabel(item);
  if (label === "Annual") return "A";
  if (label === "Semi-Annual") return "S";
  if (label === "Monthly") return "M";
  return "D";
};

export const formatPurchaseSourceLabel = (value) => {
  if (!value) return "--";
  const lowered = String(value).trim().toLowerCase();
  if (!lowered) return "--";
  if (lowered.includes("shopify")) return SOURCE_LABELS.shopify;
  if (lowered.includes("wordpress")) return SOURCE_LABELS.wordpress;
  if (lowered.includes("admin")) return SOURCE_LABELS.admin;
  if (lowered.includes("website")) return SOURCE_LABELS.website;
  return String(value)
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const formatRegistrationSourceLabel = (value) => {
  const lowered = String(value || "").trim().toLowerCase();
  if (!lowered) return SOURCE_LABELS.unknown;
  if (lowered.includes("shopify")) return SOURCE_LABELS.shopify;
  if (lowered.includes("wordpress")) return SOURCE_LABELS.wordpress;
  if (lowered.includes("admin")) return SOURCE_LABELS.admin;
  if (lowered.includes("website")) return SOURCE_LABELS.website;
  if (lowered.includes("unknown")) return SOURCE_LABELS.unknown;
  return String(value)
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const getMembershipStatusLabel = (status) =>
  Number(status) === 1 ? "Active" : "Expired";

export const getMembershipStatusClass = (status) =>
  Number(status) === 1 ? "success" : Number(status) === 0 ? "warning" : "danger";

export const getUserStatusClass = (status) => {
  const normalized = Number(status);
  if (normalized === 1) return "success";
  if (normalized === 2) return "warning";
  return "danger";
};
